







































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import BaseMixin from '@/components/mixins/base';
import DxButton from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxRequiredRule, DxValidator, DxStringLengthRule } from 'devextreme-vue/validator';
import DxTextBox from 'devextreme-vue/text-box';
import { DxToolbarItem } from 'devextreme-vue/popup';

import {
	apiService, customerService
} from '@/container';
import {
	Popup
} from '@/components';

@Component({
	components: {
		DxButton,
		DxCheckBox,
		DxLoadPanel,
		DxRequiredRule,
		DxStringLengthRule,
		DxTextBox, DxToolbarItem,
		DxValidator,
		Popup
	}
})
export default class AddEditDashboard extends BaseMixin {

	@Prop({ type: String, default: null }) dashboardName!: string | null;
	@Prop({ type: String, default: null }) idDashboard!: string | null;
	@Prop({ type: String, default: null }) defaulDashboardId!: string | null;
	@Prop({ type: Boolean, default: false }) isDefaultDashboard!: boolean;
	@Prop({ type: Boolean, default: false }) areDashboardsAvailable!: boolean;
	@Prop({ type: Boolean, default: false }) areEnabledDashboardsAvailable!: boolean;

	internalDashboardName: string | null = null;
	internalIsDefaultDashboard = false;

	position = { of: '#add-edit-dashboard' };
	isSaving = false;

	readonly maxNameLength: number = 30;
	loading = false;
	isNameValid = true;
	isOverrideDefaultAccepted = false;
	showOverrideDefaultPopup = false;

	async created() {
		if (!this.isAdd) {
			var dashboard = await apiService.get('dashboards', `${this.idDashboard}`);
			this.internalIsDefaultDashboard = dashboard.isDefault;
		}
		else {
			this.internalIsDefaultDashboard = this.isDefaultDashboard;
		}
	}

	get isAdd() {
		return !this.isUpdate;
	}

	get isUpdate() {
		return _.isString(this.dashboardName);
	}

	get title() {
		if (this.isAdd)
			return this.$t('dashboard.add.title');
		return this.$t('dashboard.edit.title');
	}

	get dashboardAddEditMessage() {
		if (!this.areDashboardsAvailable)
			return 'dashboard.createFirst';
		else if (this.isAdd)
			return 'dashboard.create';
		return 'dashboard.edit';
	}

	get saveButtonProps() {
		return {
			class: 'ml-2',
			disabled: !_.isString(this.internalDashboardName) || this.internalDashboardName.trim() === '' || this.isSaving,
			icon: 'far fa-save',
			text: this.$t('dashboard.save'),
			type: 'default'
		};
	}

	get closeButtonProps() {
		return {
			class: 'mr-2',
			icon: 'far fa-times',
			text: this.$t('dashboard.close'),
			type: 'default'
		};
	}

	get rejectButtonProps() {
		return {
			location: 'after',
			options: {
				class: 'mr-2',
				icon: 'far fa-times',
				onClick: this.onRejectClick,
				stylingMode: 'outlined',
				text: this.$t('dashboard.addEdit.reject'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}
	get acceptButtonProps() {
		return {
			location: 'after',
			options: {
				class: 'mr-2',
				icon: 'far fa-check',
				onClick: this.onAcceptClick,
				stylingMode: 'outlined',
				text: this.$t('dashboard.addEdit.accept'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	async onRejectClick() {
		this.showOverrideDefaultPopup = false;
	}

	async onAcceptClick() {
		this.isOverrideDefaultAccepted = true;
		this.showOverrideDefaultPopup = false;
		await this.onSaveClick();
	}

	async onSaveClick() {
		const dataToEmit = {
			idDashboard: this.idDashboard,
			name: this.internalDashboardName,
			isDefault: this.internalIsDefaultDashboard,
			idCustomer: customerService.getCustomer()
		};

		if (dataToEmit.isDefault && _.isString(this.defaulDashboardId) && this.defaulDashboardId !== dataToEmit.idDashboard) {
			if (this.isOverrideDefaultAccepted)
				this.isOverrideDefaultAccepted = false;
			else {
				this.showOverrideDefaultPopup = true;
				return;
			}
		}

		try {
			this.isSaving = true;
			if (this.isAdd) {
				const r = await apiService.post('dashboards', 'create', dataToEmit);
				dataToEmit.idDashboard = r.id;
			}
			else
				await apiService.post('dashboards', `${this.idDashboard}/update`, dataToEmit);
		} finally {
			this.isSaving = false;
		}

		let eventToEmit = 'add:dashboard';
		if (this.isUpdate)
			eventToEmit = 'update:dashboard';
		this.$emit(eventToEmit, dataToEmit);
		this.onCloseClick();
	}

	onCloseClick() {
		this.$emit('close');
	}

	@Watch('dashboardName', { immediate: true })
	onDashboardNameChange(newValue: string | null) {
		this.internalDashboardName = newValue;
	}
}
